
import { MultiBonusCommonConfiguration } from "../../../api";
import { Settings } from "../../../Settings";
import { SpinAndHoldBonus } from "../SpinAndHold/SpinAndHold";
import { SpinAndHoldParams } from "../SpinAndHold/SpinAndHoldParams";
import { MultiBonusPIXIApp } from "./MultiBonusPIXIApp";
import { MultiBonusPIXIAppResponsive } from "./MultiBonusPIXIAppResponsive";

export interface IMultiBonusFactory
{
	CreateMultiBonus(gameName: string, params: SpinAndHoldParams, config: MultiBonusCommonConfiguration): SpinAndHoldBonus;
	CreateMultiBonusPIXIApp(gameName: string, params: SpinAndHoldParams, config: MultiBonusCommonConfiguration): MultiBonusPIXIApp;
	CreateMultiBonusPIXIAPPResponsive(gameName: string, params: SpinAndHoldParams, config: MultiBonusCommonConfiguration): MultiBonusPIXIAppResponsive;
}

export class MultiBonusFactory implements IMultiBonusFactory
{
	public CreateMultiBonus(gameName: string, params: SpinAndHoldParams, config: MultiBonusCommonConfiguration): SpinAndHoldBonus
	{
		throw new Error("MultiBonus in html is not implemented");
	}

	public CreateMultiBonusPIXIApp(gameName: string, params: SpinAndHoldParams, config: MultiBonusCommonConfiguration): MultiBonusPIXIApp
	{
		return new MultiBonusPIXIApp(gameName, params, config);
	}

	public CreateMultiBonusPIXIAPPResponsive(gameName: string, params: SpinAndHoldParams, config: MultiBonusCommonConfiguration): MultiBonusPIXIAppResponsive
	{
		if (Settings.Screens !== 1) throw new Error("MultiBounus Responsive is only implemented for 1 Screen");

		return new MultiBonusPIXIAppResponsive(gameName, params, config);
``	}
}